export const html = "<p>Brave a bowl of traditional khash by Stone Lake.</p>\n";
export const leadHtml = "<p>Brave a bowl of traditional khash by Stone Lake.</p>\n";
export const bodyHtml = "";
export const metaText = "Brave a bowl of traditional khash by Stone Lake.";